/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_IDENT_FAULT_GROUPS } from '../../actions.type'
import {
  CREATE_IDENT_FAULT_GROUP,
  REMOVE_IDENT_FAULT_GROUP,
  SET_IDENT_FAULT_GROUP_ALL_REQUEST,
  SET_IDENT_FAULT_GROUP_ALL_VALUE,
  UPDATE_IDENT_FAULT_GROUP
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  identFaultGroupAllValue: (state) => state.all.value,
  identFaultGroupAllRequest: (state) => state.all.request,
  identFaultGroupAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  async [FETCH_IDENT_FAULT_GROUPS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('ident-fault-group', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_IDENT_FAULT_GROUP_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_IDENT_FAULT_GROUP_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_IDENT_FAULT_GROUP_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_IDENT_FAULT_GROUP_ALL_VALUE, data)
    } catch (e) {
      commit(SET_IDENT_FAULT_GROUP_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_IDENT_FAULT_GROUP({ commit }, value) {
    commit(CREATE_IDENT_FAULT_GROUP, value)
  },

  async SOCKET_UPDATE_IDENT_FAULT_GROUP({ commit }, value) {
    commit(UPDATE_IDENT_FAULT_GROUP, value)
  },

  async SOCKET_REMOVE_IDENT_FAULT_GROUP({ commit }, id) {
    commit(REMOVE_IDENT_FAULT_GROUP, id)
  }
}

const mutations = {
  [SET_IDENT_FAULT_GROUP_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_IDENT_FAULT_GROUP_ALL_VALUE](state, identFaultGroups) {
    state.all.value = identFaultGroups
  },
  [UPDATE_IDENT_FAULT_GROUP](state, updatedIdentFaultGroup) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedIdentFaultGroup.id }),
      1,
      updatedIdentFaultGroup
    )
  },
  [CREATE_IDENT_FAULT_GROUP](state, createdIdentFaultGroup) {
    state.all.value.push(createdIdentFaultGroup)
  },
  [REMOVE_IDENT_FAULT_GROUP](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
